<template>
  <Modal
    name="GROUP_SET_HOST_MODAL"
    :title="$t(`appointment.group.hostModal.${groupHost ? 'changeHost' : 'addHost'}`)"
    ref="modal"
    actions
  >
    <template v-slot:body>
      <div v-if="groupHost">
        <h6 class="text-uppercase grey--text mb-0">
          {{ $t('appointment.group.hostModal.currentHost') }}
        </h6>
        <p class="mb-0">
          {{ groupHost.name }}
        </p>
        <p class="body-2 mb-6">
          {{ groupHost.username }}
        </p>
      </div>
      <HostSelect
        v-model="host"
        :rules="[rules.required]"
        :dense="false"
        :notBlockedForGroupId="groupId"
      />
      <span v-if="sameHostSelected" class="body-2 error--text">
        {{ $t('appointment.group.hostModal.changeHostWarningMessage') }}
      </span>

      <div v-if="host" class="mt-5">
        <h6 class="text-uppercase grey--text mb-0">
          {{ $t('appointment.group.hostModal.host') }}
        </h6>
        <p class="mb-0">
          {{ host.name }}
        </p>
        <p class="body-2 mb-1">
          {{ host.username }}
        </p>
        <p class="body-2 mb-1">
          {{ host.phone }}
        </p>
      </div>
    </template>
    <template v-slot:actions>
      <v-btn @click="closeAllModals" :disabled="isLoading" elevation="0" class="mr-5" text>
        {{ $t('appointment.buttons.cancel') }}
      </v-btn>

      <v-btn @click="validate" :loading="isLoading" :disabled="disabled" color="primary" elevation="0">
        {{ $t('appointment.group.hostModal.confirm') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import { required } from '@/util/errorHandling'

import Modal from '@/components/app/Modal'
import HostSelect from '@/components/host/HostSelect'

export default {
  name: 'ModalGroupSetHost',

  components: {
    Modal,
    HostSelect,
  },

  props: {
    groupId: {
      type: String,
      required: true,
    },

    groupHost: {
      type: Object,
      default: null,
    },
  },

  computed: {
    sameHostSelected() {
      return this.groupHost && this.host && this.host.id == this.groupHost.id
    },

    disabled() {
      return this.host == null || this.sameHostSelected
    },
  },

  methods: {
    ...mapActions(['setGroupHost', 'unassignGroupHost']),
    ...mapMutations(['closeAllModals']),

    validate() {
      if (this.disabled) return

      this.isLoading = true

      Promise
        .resolve(this.setGroupHost({ groupId: this.groupId, hostId: this.host.id }))
        .finally(() => {
          this.isLoading = false
          this.$parent.$parent.refreshMap()
        })
    },

    removeHost() {
      this.isLoading = true

      Promise
        .resolve(this.unassignGroupHost({ group_id: this.groupId }))
        .finally(() => {
          this.isLoading = false
          this.$parent.$parent.refreshMap()
        })
    }
  },

  data() {
    return {
      host: null,
      isLoading: false,
      rules: {
        required
      },
    }
  },

  mounted() {
    this.$watch(() => this.$refs.modal.dialog, (value) => {
      if (value) this.host = null
    })
  }
}
</script>
